import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Tours = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <div className="flex-grow flex items-center justify-center bg-gray-50">
        <div className="text-center px-4">
          <h1 className="text-6xl font-serif text-gray-800 mb-4">Coming Soon</h1>
          <p className="text-xl text-gray-600">Our tours section is under development</p>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Tours;